import { useQuery } from '@tanstack/react-query'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import { auditApi } from '../api/client'
import './VetoRateTrends.css'

// Fixed-height chart tile — intentionally NOT an expandable panel: the bar
// chart is a fixed-height ResponsiveContainer, so a scroll/expand toggle
// would be a no-op. (See 2026-06-07 dashboard layout spec.)
export function VetoRateTrends() {
  const q = useQuery({ queryKey: ['veto-rates'],
    queryFn: () => auditApi.vetoRates(7), refetchInterval: 60000 })
  const data = (q.data?.rules ?? []).map((r) => ({
    rule: r.rule_name,
    rate: Number((r.reject_rate * 100).toFixed(1)),
    rejects: r.rejects,
  }))
  return (
    <div className="card veto-trends">
      <h3>Rule veto rates · 7d</h3>
      {q.isLoading && <p className="vt-muted">Loading…</p>}
      {!q.isLoading && !q.isError && data.length === 0 && (
        <p className="vt-empty">No sanity-gate events in the window.</p>
      )}
      {q.isError && data.length === 0 && <p className="vt-muted">Failed to load veto rates.</p>}
      {data.length > 0 && (
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={data}>
            <XAxis dataKey="rule" stroke="var(--fg-subtle)" fontSize={11}
                   interval={0} angle={-20} textAnchor="end" height={60} />
            <YAxis stroke="var(--fg-subtle)" fontSize={11}
                   tickFormatter={(v) => `${v}%`} />
            <Tooltip formatter={(v: unknown) => `${v}%`} />
            <Bar dataKey="rate" fill="var(--series-1)" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  )
}
